import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchServices = () => api.get("/services").then((r) => r.data);
export const fetchService = (slug) => api.get(`/services/${slug}`).then((r) => r.data);
export const fetchProjects = (category) =>
  api.get("/projects", { params: category && category !== "All" ? { category } : {} }).then((r) => r.data);
export const fetchProject = (slug) => api.get(`/projects/${slug}`).then((r) => r.data);
export const fetchJobs = () => api.get("/jobs").then((r) => r.data);
export const fetchJob = (slug) => api.get(`/jobs/${slug}`).then((r) => r.data);
export const submitApplication = (data) => api.post("/applications", data).then((r) => r.data);
export const submitInquiry = (data) => api.post("/inquiries", data).then((r) => r.data);
export const fetchStats = () => api.get("/stats").then((r) => r.data);
